import { useAuth0 } from '@auth0/auth0-react';
import { makeStyles } from "@material-ui/core/styles";
import Card from "@mui/material/Card";
import CommunicationService from 'Lib/API/Communication';
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from 'react';
import { toastr } from "react-redux-toastr";
import { AutomationTable } from './AutomationTable';

export const Automation = ({setToggle}) => {
    const { getAccessTokenSilently } = useAuth0();
    const [page, setPage] = useState(0);
    const [atomationList,setAutomationList] = useState([])
    const [loading,setLoading] = useState(false)
    const [searchValue, setSearchValue] = React.useState("");
    const [count, setCount] = useState();
    const [refresh, setRefresh] = useState(false);
    const [sortBy, setSortBy] = useState("all");
    const [campainDetailsId,setCampainDetailsId] = useState('')
    const [sorting, setSorting] = useState({
        sort: {},
        search: undefined,
      });

      const useStyles = makeStyles({
        card: {
          borderRadius: "0",
          boxShadow: "none !important",
          height:'100%',
          "&:hover": {
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
          },
          marginTop:20,
          marginRight:20
        },

      });
      const classes = useStyles();

    const getCampaignList = async ()=>{
        setLoading(true)
        const filterData = {
          ...sorting,
          filter: {
            status: sortBy
        },
        }
        try{
            const token = await getAccessTokenSilently();
            const result = await CommunicationService.getAutomationList(token , page + 1,30,filterData)
            setCount(result?.payload?.pagination?.count);
            setAutomationList(result?.payload?.data)
        }catch(err){
            toastr.error("Error", err?.data?.message);
        }finally{
            setLoading(false)
        }
    }
    useEffect(() => {
        if (searchValue === "") {
          setSorting({ ...sorting, search: undefined });
        } else {
          setSorting({ ...sorting, search: searchValue });
        }
      }, [searchValue]);
      
      const handleInputChange = (e) => {
        setPage(0);
        const inputValue = e.target.value;
        const regex = /[\\*\(\)\+]/;
        if (!regex.test(inputValue)) {
          setSearchValue(inputValue);
        }
      };


      const debounceSearch = useCallback(
        debounce(() => {
          if (sorting?.search) {
            getCampaignList();
          }
        }, 1000),
        [sorting?.search, sortBy, page, refresh]
      );
    
      useEffect(() => {
        if (sorting?.search) {
          debounceSearch();
        } else {
          getCampaignList();
        }
        return () => debounceSearch.cancel();
      }, [sorting,page,refresh,sortBy]);
    
      const onSortChange = (value) => {
        setPage(0);
        setSortBy(value);
      }


      const handleSort = (name) => {
        setSorting((prev) => ({
          ...prev,
          sort: {
            [name]: prev.sort[name] === 1 ? -1 : 1,
          },
        }));
      };
    return (
      <Card className={classes.card}>
        <AutomationTable
           setToggle={setToggle}
           atomationList={atomationList} page={page} loading={loading} 
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleInputChange={handleInputChange}
            setPage={setPage}
            setCount={setCount}
            count={count}
            handleSort={handleSort}
            refresh={refresh}
            setRefresh={setRefresh}
            onSortChange={onSortChange}
            setCampainDetailsId={setCampainDetailsId}
            />
        </Card>
    );
};

